const CLICKABLE = false;
const NOTCLICKABLE = true;

export default class SpecsHomeAccordion {
  constructor(accordionEventListener, accordionContent, activeClass){
    this.accordionEventListener = document.querySelectorAll(accordionEventListener);
    this.accordionContent = document.querySelectorAll(accordionContent);
    this.activeClass = activeClass;
    // Optional variable, to control clickability in mobile/desktop widths
    this.clickStatus = CLICKABLE;
  }

  initEventListeners(){
    this.accordionEventListener.forEach( (e) => {
      e.addEventListener('click', (event) => {
        // Disables click of the element
        if (this.clickStatus === NOTCLICKABLE) {
          event.preventDefault();
        }
        // If you click on that same open accordion, it closes it
        else if (e.parentNode.classList.contains(this.activeClass)) {
          this.close(e.parentNode);
        }
        // Only one accordion can be open at time
        else {
          this.closeAll();
          this.open(e.parentNode);
        }
      });
    });
  }

  open(element){
    element.classList.add(this.activeClass);
  }

  close(element){
    element.classList.remove(this.activeClass);
  }

  closeAll(){
    this.accordionContent.forEach( (e) => {
      e.classList.remove(this.activeClass);
    });
  }

  disableClick(){
    this.clickStatus = NOTCLICKABLE;
  }

  enableClick(){
    this.clickStatus = CLICKABLE;
  }
}
